/**
 * Years of experience, as the questionnaire stores them: a range id, never a
 * number.
 *
 * "0-1", "2-3", "4-6", "7-10", "10+" (and "0" for sustainability). Feeding
 * those to `Number()` yields NaN, which is why the years line silently never
 * rendered on a card once. Two readings come out of one value: a label to show,
 * and a lower bound to sort by. Sorting on the bound keeps "10+" above "7-10"
 * without inventing a precision the answer never had.
 *
 * Import-free, because the employer dashboard on the site reads it too; see
 * `tests/shared-config-imports.test.mjs`.
 */

/** Compact, for a line of metadata in a list. */
const EXPERIENCE_LABELS: Record<string, string> = {
    "0": "sin experiencia",
    "0-1": "<1 año",
    "2-3": "2–3 años",
    "4-6": "4–6 años",
    "7-10": "7–10 años",
    "10+": "10+ años"
};

export function experienceLabel(value: unknown): string | null {
    if (typeof value !== "string" || value === "") return null;
    return EXPERIENCE_LABELS[value] ?? value;
}

export function experienceFloor(value: unknown): number | null {
    if (typeof value !== "string" || value === "") return null;
    const match = value.match(/^(\d+)/);
    return match ? Number(match[1]) : null;
}

/**
 * The number that orders candidates: experience in sustainability, falling back
 * to total experience when only that was answered.
 */
export function relevantExperienceFloor(questionnaire: unknown): number | null {
    const q = questionnaire && typeof questionnaire === "object" && !Array.isArray(questionnaire)
        ? questionnaire as Record<string, unknown>
        : {};
    return experienceFloor(q.years_experience_sustainability) ?? experienceFloor(q.years_experience_total);
}
